import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  OnInit,
} from "@angular/core";

@Component({
  selector: "app-client-profile",
  templateUrl: "./client-profile.component.html",
  styleUrls: ["./client-profile.component.css"],
})
export class ClientProfileComponent implements OnChanges, OnInit {
  @Input() client: any;
  @Input() isEditMode: boolean = false;
  @Input() canEdit: boolean = true;
  @Input() states: any[];
  @Input() phoneMask: any;
  @Input() dateInputMask: any;
  @Input() zipMask: any;
  @Output() hasChanges = new EventEmitter<boolean>();

  private originalClient: string;

  ngOnInit() {
    this.parseDatesFromClient();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["client"] && this.client) {
      this.parseDatesFromClient();
    }
    if (changes["isEditMode"] && this.isEditMode) {
      this.originalClient = JSON.stringify(this.client);
    }
  }

  parseDatesFromClient() {
    if (!this.client) return;

    if (this.client.validFrom) this.client.validFrom = new Date(this.client.validFrom);
    if (this.client.validTo) this.client.validTo = new Date(this.client.validTo);

    if (!this.client.children) return;

    for (const client of this.client.children) {
      if (client.validFrom) client.validFrom = new Date(client.validFrom);
      if (client.validTo) client.validTo = new Date(client.validTo);
    }
  }

  onFieldChange() {
    if (this.isEditMode && this.originalClient) {
      const currentClient = JSON.stringify(this.client);
      this.hasChanges.emit(currentClient !== this.originalClient);
    }
  }
}
